import { mmFetchWithResponse } from './mmFetchWithResponse';

const systemApi = {
    dbiScanStrDeepDive: async (scanStr) => {
        const url = `api/system/v1/orderDeepDive?dbiScanStr=${scanStr}`;
        return mmFetchWithResponse(url);
    },
    getCCPARequests: async () => {
        const url = `api/ccpa/v1/requests`;
        return mmFetchWithResponse(url);
    },
    getMarketplaceInventory: async (packGroupID) => {
        const url = `api/system/v1/marketplaceInventory?packGroupID=${packGroupID}`;
        return mmFetchWithResponse(url);
    },
    getMarketplaceDrinksInventory: async () => {
        const url = `api/system/v1/marketplaceInventory/drinks`;
        return mmFetchWithResponse(url);
    },
    orderDeepDive: async (orderNum) => {
        const url = `api/system/v1/orderDeepDive?orderNum=${orderNum}`;
        return mmFetchWithResponse(url);
    },
    getLiveInventoryForPackGroup: async (packGroupID) => {
        const url = `api/inventory/v1/ims?packGroupID=${packGroupID}`;
        return mmFetchWithResponse(url);
    },
    getLiveInventoryDetailsForSellableItem: async (sellableItemID) => {
        const url = `api/inventory/v1/ims/item?id=${sellableItemID}`;
        return mmFetchWithResponse(url);
    },
    imperfectDeepDive: async (imperfectID) => {
        const url = `api/system/v1/orderDeepDive?imperfectID=${imperfectID}`;
        return mmFetchWithResponse(url);
    },
    shipmentDeepDive: async (shipmentID) => {
        const url = `api/system/v1/orderDeepDive?shipmentID=${shipmentID}`;
        return mmFetchWithResponse(url);
    },
    routeProviderDeepDive: async (routeProviderExternalID) => {
        const url = `api/system/v1/orderDeepDive?routeProviderExternalID=${routeProviderExternalID}`;
        return mmFetchWithResponse(url);
    },
};

export { systemApi };
